import { getTokenValue } from '../user';

export const getBasicAuthorizationHeader = () => {
  const tokenValue = getTokenValue();

  if (tokenValue) {
    const basicAuth = btoa(`pwa:${tokenValue}`);
    return process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
      ? `Bearer ${tokenValue}`
      : `Basic ${basicAuth}`;
  }

  return '';
};
